export const ASSETS = {
  portrait:
    "https://customer-assets-v7afamib.emergentagent.net/job_alpenfootball/artifacts/k4tm3v9f_ChatGPT%20Image%20Aug%208%2C%202026%2C%2001_02_06%20AM.png",
  signature:
    "https://static.prod-images.emergentagent.com/jobs/6a6d1cdf-7743-491b-9c81-ef90150e692a/images/32234be083cc68b6b5cae3d44697559a3c20792ed6a2a15c62f1b112c79a21b4.jpeg",
  office:
    "https://customer-assets-v7afamib.emergentagent.net/job_alpenfootball/artifacts/k4tm3v9f_ChatGPT%20Image%20Aug%208%2C%202026%2C%2001_02_06%20AM.png",
  austrianBall:
    "https://static.prod-images.emergentagent.com/jobs/6a6d1cdf-7743-491b-9c81-ef90150e692a/images/91fdf7a8d70928861c999dd635a6d009b62422dbf7b976bec82dcdf9f73d04dd.jpeg",
};
